
export const DEFAULT_LAYOUT = 'with-app-bar'
export const BLANK_LAYOUT = 'blank'
